import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { EstacaoService } from 'src/app/shared/services/estacao.service';
import { EstadoService } from 'src/app/shared/services/estado.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filtrar-uf',
  templateUrl: './filtrar-uf.component.html',
  styleUrls: ['./filtrar-uf.component.scss'],
})

export class FiltrarUfComponent implements OnInit {
  isDesktop: boolean;
  isTablet: boolean;

  estados: any = [];
  estadoSelecionado = '';

  constructor(
    private popoverCtrl: PopoverController,
    private platform: Platform,
    private estadoService: EstadoService,
  ) { }

  ngOnInit() {
    this.platform.ready();
    this.getEstados();

    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');

  }

  async getEstados() {
    this.estados = await this.estadoService.recuperarTodas();
    this.estadoSelecionado = this.estados.sgUf;
  }

  filtrar() {
    this.popoverCtrl.dismiss(this.estadoSelecionado);

  }

}
